import { useNavigate, useParams } from "react-router-dom";
import { useGetFoodCourt } from "../hooks/useFoodCourt";
import { useEffect, useState, useRef } from "react";
import { Search } from "lucide-react";
import { Input } from "../components/ui/input";
import FCCard from "@/components/FCCard";
import { FallingLines } from "react-loader-spinner";
import { trackEvent } from "@/lib/amplitude";

export default function OnboardingFC() {
  const params = useParams();
  const navigate = useNavigate();
  const { isLoading, isError, data } = useGetFoodCourt(params.fcId!);
  const [searchTerm, setSearchTerm] = useState("");
  const hasTrackedPageView = useRef(false);

  useEffect(() => {
    if (!hasTrackedPageView.current) {
      hasTrackedPageView.current = true;
      trackEvent("food_court_onboarding_viewed", {
        foodCourtId: params.fcId,
        source: "food_court",
      });
    }
  }, [params.fcId]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div>
          <FallingLines visible={true} height="200" width="200" color="#ff5c5c" />
        </div>
      </div>
    );
  }
  if (isError) {
    return <div>Error</div>; // todo: add error page
  }
  return (
    <div className="min-h-screen w-full ">
      <div className=" mx-auto flex min-h-[100dvh] max-w-md flex-col   items-center space-y-4 px-4 pt-10">
        <div className="relative w-full  md:grow-0">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            type="search"
            placeholder="Search..."
            className="w-full rounded-lg bg-background pl-8 text-base md:w-[200px] lg:w-full"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
        </div>
        {isLoading && <div>Loading...</div>}
        {!isLoading &&
          data?.places
            .filter((value) =>
              searchTerm
                .toLowerCase()
                .split(" ")
                .every(
                  (el) =>
                    value.name.toLowerCase().includes(el) ||
                    value.address.toLowerCase().includes(el),
                ),
            )
            .map((place) => (
              <FCCard
                place={place}
                opts={data.style}
                onClick={() => {
                  trackEvent("food_court_restaurant_selected", {
                    foodCourtId: params.fcId,
                    restaurantUid: place.uid,
                    restaurantName: place.name,
                    source: "food_court",
                  });
                  window.localStorage.setItem("placeRef", place.uid);
                  navigate("/upload");
                }}
              />
            ))}
      </div>
    </div>
  );
}
